module.exports = __webpack_public_path__ + "img/score-bg.766962fe.png";